export interface FiscalYearLike {
  id?: string;
  _id?: string;
  start_date: string;
  end_date: string;
}

export function resolvePreviousFiscalYear(
  fiscalYears: FiscalYearLike[],
  current: { start_date: string },
): { id: string; start_date: string; end_date: string } | null {
  const currentStart = new Date(current.start_date)

  const candidates = fiscalYears
    .filter(fy => new Date(fy.end_date) < currentStart)
    .sort((a, b) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime())

  if (candidates.length === 0) return null

  const prev = candidates[0]
  return {
    id: prev.id ?? prev._id ?? '',
    start_date: prev.start_date,
    end_date: prev.end_date,
  }
}

export function previousBalanceSheetDate(prev: { end_date: string }): string {
  return prev.end_date
}

export function previousPeriodBounds(prev: { start_date: string; end_date: string }): { from: string; to: string } {
  return { from: prev.start_date, to: prev.end_date }
}
